/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["tab"] }] */
// TODO: extract constant

const activateTab = (tab) => {
  if (tab) {
    tab.setAttribute('aria-selected', 'true')
    tab.classList.add('-is-checked')
    if (tab.tabPanel) {
      tab.tabPanel.classList.add('-is-checked')
    }
    if (tab.tabList) {
      tab.tabList.selectedTab = tab
    }
  }
}

const deactivateTab = (tab) => {
  if (tab) {
    tab.setAttribute('aria-selected', 'false')
    tab.classList.remove('-is-checked')
    if (tab.tabPanel) {
      tab.tabPanel.classList.remove('-is-checked')
    }
  }
}

const selectTab = (tab) => {
  if (!tab || !tab.tabList) {
    return
  }
  if (tab.tabList.selectedTab === tab) {
    return
  }
  deactivateTab(tab.tabList.selectedTab)
  activateTab(tab)
}

class TabList {
  constructor(element) {
    if (
      !document ||
      !document.body ||
      !element ||
      element.getAttribute('role') !== 'tablist'
    ) {
      return
    }

    this.element = element
    this.element.tabList = this

    this.tabs = element.querySelectorAll('[role=tab]')
    this.selectedTab = undefined

    this.tabs.forEach((tab) => {
      tab.tabList = this
      tab.tabPanel = document.getElementById(tab.getAttribute('aria-controls'))
      if (
        !this.selectedTab &&
        (tab.getAttribute('aria-selected') === 'true' ||
          tab.classList.contains('-is-checked'))
      ) {
        activateTab(tab)
      } else {
        deactivateTab(tab)
      }
    })

    if (!this.selectedTab && this.tabs.length > 0) {
      const { value: tab } = this.tabs.values().next()
      activateTab(tab)
    }
  }

  selectTabByIndex(index) {
    selectTab(this.tabs.item(index))
  }

  selectTab(tab) {
    if (tab && this === tab.tabList) {
      selectTab(tab)
    }
  }
}

export { TabList as default }
